import { useHistory } from 'react-router-dom';

// 修复useHistory在Router组件外使用时的报错
const useSafeHistory = () => {
    try {
        return useHistory();
    } catch (error) {
        return null;
    }
};

export default useSafeHistory;
